import React from 'react'
import { Box, Grid, Typography } from "@mui/material"
import { useComputed } from "@preact/signals-react"
import { reportListMultipleData } from "Pages/ReportsAlerts/Reports/@signals"

export default function MultipleModalFrequencyInfoSection() {
	const reportsInfo = useComputed(() => reportListMultipleData.value.reportsInfo)
	return (
		<Grid container spacing={2}>
			{reportsInfo.value.map(({ name, idFrequencyWhenTranslation, frequencyHours }, idx) => (
				<Grid item xs={12} key={`${name}-${idx}`} sx={{ display: "flex", alignItems: "center" }}>
					<Typography variant="body1" color="primary" sx={{ minWidth: 150, fontWeight: "bold" }}>{name}:</Typography>
					<Box sx={{ display: "flex", flexDirection: "column", gap: .5, ml: 1 }}>
						<Typography variant="subtitle1" color="text.secondary" fontWeight="bold">
							Days: <Typography component="span" color="text.primary">{idFrequencyWhenTranslation}</Typography>
						</Typography>
						<Typography variant="subtitle1" color="text.secondary" fontWeight="bold">
							Hours: <Typography component="span" color="text.primary">{frequencyHours?.join(', ')}</Typography>
						</Typography>
					</Box>
				</Grid>
			))}
		</Grid>
	)
}
